
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { StocktackingUser, ToolCorrectionType__ToI18nString, StocktakingFoundAfterwardsDto_$reflection, StocktakingFoundAfterwardsDto, StocktakingCorrectionDto_$reflection, StocktakingCorrectionDto, ToolCorrectionType, StocktakingResultType_$reflection, ToolCorrectionType_$reflection } from "../../Shared/Stocktaking.js";
import { class_type, record_type, lambda_type, unit_type, string_type, option_type, list_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, FormState__setValidations_Z51B1D053, FormState_get_empty, ClientApiResponse$1_$reflection, FormState_$reflection, StocktakingListId_$reflection, StocktakingId_$reflection } from "../../Shared/Shared.js";
import { tryFind, append, sortBy, map, empty, singleton, isEmpty, ofArray, choose } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_ofEffect, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { StocktakingListId__get_unwrap, StocktakingId__get_unwrap } from "../../Shared/Shared.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { List_distinctBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { equals, createObj, comparePrimitives, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Select } from "../../Components/Select.js";
import { defaultArg, map as map_1, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { InformationAlert } from "../../Components/Alert.js";
import { TextArea } from "../../Components/TextArea.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { TextButton } from "../../Components/Button.js";

class ToolAction extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Correction", "FoundAfterwards"];
    }
}

function ToolAction_$reflection() {
    return union_type("Stocktaking.Dialog.CorrectionBookingDialog.ToolAction", [], ToolAction, () => [[["Item", ToolCorrectionType_$reflection()]], []]);
}

class State extends Record {
    constructor(StocktakingId, StocktakingListId, StocktakingResultType, ToolAction, BookingText, CountedBy, FormState, OnClose) {
        super();
        this.StocktakingId = StocktakingId;
        this.StocktakingListId = StocktakingListId;
        this.StocktakingResultType = StocktakingResultType;
        this.ToolAction = ToolAction;
        this.BookingText = BookingText;
        this.CountedBy = CountedBy;
        this.FormState = FormState;
        this.OnClose = OnClose;
    }
}

function State_$reflection() {
    return record_type("Stocktaking.Dialog.CorrectionBookingDialog.State", [], State, () => [["StocktakingId", StocktakingId_$reflection()], ["StocktakingListId", StocktakingListId_$reflection()], ["StocktakingResultType", option_type(list_type(StocktakingResultType_$reflection()))], ["ToolAction", ToolAction_$reflection()], ["BookingText", string_type], ["CountedBy", option_type(string_type)], ["FormState", FormState_$reflection()], ["OnClose", lambda_type(unit_type, unit_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetBookingText", "SetToolAction", "SetCountedBy", "SaveStocktakingCorrection", "FoundAfterwardsSaved", "StocktakingCorrectionSaved", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Stocktaking.Dialog.CorrectionBookingDialog.Msg", [], Msg, () => [[["Item", string_type]], [["Item", ToolAction_$reflection()]], [["Item", option_type(string_type)]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function toolIds(stocktakingResults) {
    return choose((stocktakingResultType) => {
        if (stocktakingResultType.tag === 0) {
            return stocktakingResultType.fields[0];
        }
        else {
            return undefined;
        }
    }, stocktakingResults);
}

function toolWithQuantityIds(stocktakingResults) {
    return choose((stocktakingResultType) => {
        if (stocktakingResultType.tag === 1) {
            return stocktakingResultType.fields[0];
        }
        else {
            return undefined;
        }
    }, stocktakingResults);
}

function consumableIds(stocktakingResults) {
    return choose((stocktakingResultType) => {
        if (stocktakingResultType.tag === 2) {
            return stocktakingResultType.fields[0];
        }
        else {
            return undefined;
        }
    }, stocktakingResults);
}

function init(stocktaking, stocktakingListId, stocktakingResultType, userId, onClose) {
    return [new State(stocktaking.Id, stocktakingListId, stocktakingResultType, new ToolAction(0, [new ToolCorrectionType(1, [])]), "", userId, FormState_get_empty(), onClose), Cmd_none()];
}

function correctionCmd(state, stocktakingResults, toolIds_1, toolCorrectionType, successMsg) {
    const dto = new StocktakingCorrectionDto(state.BookingText, toolIds_1, toolCorrectionType, toolWithQuantityIds(stocktakingResults), consumableIds(stocktakingResults));
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [`/api/stocktakings/${StocktakingId__get_unwrap(state.StocktakingId)}/lists/${StocktakingListId__get_unwrap(state.StocktakingListId)}/correction`, toString(0, Auto_generateBoxedEncoder_437914C6(StocktakingCorrectionDto_$reflection(), undefined, undefined, undefined)(dto))], successMsg, (Item) => (new Msg(6, [Item])));
}

function hasQuantityPositions(stocktakingResults) {
    if (!isEmpty(toolWithQuantityIds(stocktakingResults))) {
        return true;
    }
    else {
        return !isEmpty(consumableIds(stocktakingResults));
    }
}

function foundAfterwardsCmd(state, stocktakingResults) {
    let dto, successMsg;
    const matchValue = state.CountedBy;
    if (matchValue == null) {
        return undefined;
    }
    else {
        const countedBy = matchValue;
        return (dto = (new StocktakingFoundAfterwardsDto(toolIds(stocktakingResults), countedBy)), (successMsg = (hasQuantityPositions(stocktakingResults) ? ((Item) => (new Msg(4, [Item]))) : ((Item_1) => (new Msg(5, [Item_1])))), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_2;
            return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
            }, refreshOn)))(true);
        })), [`/api/stocktakings/${StocktakingId__get_unwrap(state.StocktakingId)}/lists/${StocktakingListId__get_unwrap(state.StocktakingListId)}/found-afterwards`, toString(0, Auto_generateBoxedEncoder_437914C6(StocktakingFoundAfterwardsDto_$reflection(), undefined, undefined, undefined)(dto))], successMsg, (Item_2) => (new Msg(6, [Item_2])))));
    }
}

const foundAfterwardsValidations = singleton(["recordedBy", "validation.stocktaking.found_afterwards.counted_by_required"]);

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, msg.fields[0], state.BookingText, state.CountedBy, FormState__setValidations_Z51B1D053(state.FormState, empty()), state.OnClose), Cmd_none()];
        case 2:
            return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, state.ToolAction, state.BookingText, msg.fields[0], state.FormState, state.OnClose), Cmd_none()];
        case 3: {
            const matchValue = state.StocktakingResultType;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const stocktakingResults = matchValue;
                const matchValue_1 = state.ToolAction;
                if (matchValue_1.tag === 1) {
                    const matchValue_2 = foundAfterwardsCmd(state, stocktakingResults);
                    if (matchValue_2 == null) {
                        return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, state.ToolAction, state.BookingText, state.CountedBy, FormState__setValidations_Z51B1D053(state.FormState, foundAfterwardsValidations), state.OnClose), Cmd_none()];
                    }
                    else {
                        const foundCmd = matchValue_2;
                        return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, state.ToolAction, state.BookingText, state.CountedBy, FormState__startLoading(state.FormState), state.OnClose), foundCmd];
                    }
                }
                else {
                    return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, state.ToolAction, state.BookingText, state.CountedBy, FormState__startLoading(state.FormState), state.OnClose), correctionCmd(state, stocktakingResults, toolIds(stocktakingResults), matchValue_1.fields[0], (Item) => (new Msg(5, [Item])))];
                }
            }
        }
        case 4: {
            const response = msg.fields[0];
            const matchValue_3 = state.StocktakingResultType;
            if (response.tag === 1) {
                return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, state.ToolAction, state.BookingText, state.CountedBy, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.OnClose), Cmd_errorToast("validation.toast")];
            }
            else if (matchValue_3 == null) {
                return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, state.ToolAction, state.BookingText, state.CountedBy, FormState_get_empty(), state.OnClose), Cmd_ofEffect((_arg) => {
                    state.OnClose();
                })];
            }
            else {
                const stocktakingResults_1 = matchValue_3;
                return [state, correctionCmd(state, stocktakingResults_1, empty(), new ToolCorrectionType(1, []), (Item_1) => (new Msg(5, [Item_1])))];
            }
        }
        case 5: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, state.ToolAction, state.BookingText, state.CountedBy, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.OnClose), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, state.ToolAction, state.BookingText, state.CountedBy, FormState_get_empty(), state.OnClose), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })];
            }
        }
        case 6:
            return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, state.ToolAction, state.BookingText, state.CountedBy, FormState_get_empty(), state.OnClose), Cmd_none()];
        default:
            return [new State(state.StocktakingId, state.StocktakingListId, state.StocktakingResultType, state.ToolAction, msg.fields[0], state.CountedBy, state.FormState, state.OnClose), Cmd_none()];
    }
}

function DialogBody(props) {
    let elems_1;
    const t = useTranslation()[0];
    const actionOption = (toolAction_1) => {
        let toolAction;
        return {
            label: (toolAction = toolAction_1, (toolAction.tag === 1) ? t("stocktaking.tool_correction_type.found_afterwards") : t(ToolCorrectionType__ToI18nString(toolAction.fields[0]))),
            value: toolAction_1,
        };
    };
    const counters = map((user_2) => ({
        label: user_2.Name,
        value: user_2.Id,
    }), sortBy((user_1) => user_1.Name, List_distinctBy((user) => user.Id, append(props.Stocktaking.Helpers, append(props.Stocktaking.ResponsiblePersons, singleton(props.CurrentUser))), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }));
    const showBookingText = (props.ToolAction.tag === 1) ? props.ContainsQuantityPositions : true;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_1 = toList(delay(() => {
        let Label, Options, Value;
        return append_1(props.ContainsTools ? singleton_1(createElement(Select, (Label = t("stocktaking.tool_correction_type.title"), (Options = ofArray([actionOption(new ToolAction(0, [new ToolCorrectionType(1, [])])), actionOption(new ToolAction(0, [new ToolCorrectionType(0, [])])), actionOption(new ToolAction(1, []))]), (Value = actionOption(props.ToolAction), {
            ComponentState: props.ComponentState,
            IsClearable: false,
            Label: unwrap(Label),
            NoOptionsMessage: "",
            OnChange: (value_1) => {
                if (value_1 == null) {
                }
                else {
                    props.Dispatch(new Msg(1, [value_1.value]));
                }
            },
            Options: Options,
            PlaceholderKey: "",
            TestId: "stocktaking-tool-correction-type",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "toolCorrectionType")),
            Value: unwrap(Value),
        }))))) : empty_1(), delay(() => {
            let elems;
            return append_1((props.ToolAction.tag === 0) ? (empty_1()) : append_1(singleton_1(reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-found-afterwards-hint"], (elems = [createElement(InformationAlert, {
                Label: "stocktaking.found_afterwards.hint",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let Label_1, Value_1;
                return singleton_1(createElement(Select, (Label_1 = t("stocktaking.found_afterwards.counted_by"), (Value_1 = tryFind((counter) => equals(counter.value, props.CountedBy), counters), {
                    ComponentState: props.ComponentState,
                    IsClearable: false,
                    Label: unwrap(Label_1),
                    NoOptionsMessage: "",
                    OnChange: (value_6) => {
                        props.Dispatch(new Msg(2, [map_1((value_7) => value_7.value, value_6)]));
                    },
                    Options: counters,
                    PlaceholderKey: "stocktaking.found_afterwards.counted_by_placeholder",
                    TestId: "stocktaking-found-afterwards-counted-by",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "recordedBy")),
                    Value: unwrap(Value_1),
                }))));
            })), delay(() => (showBookingText ? singleton_1(createElement(TextArea, {
                ComponentState: props.ComponentState,
                Label: t("stocktaking.booking_text"),
                OnChange: (arg) => {
                    props.Dispatch(new Msg(0, [arg]));
                },
                TestId: "stocktaking-result-quantity",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "booking_text")),
                Value: props.BookingText,
            })) : empty_1())));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function CorrectionBookingDialog(props) {
    let Title;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Stocktaking, props.StocktakingListId, props.StocktakingResultType, props.UserId, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.StocktakingResultType, props.Stocktaking]);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const stocktakingResults = defaultArg(props.StocktakingResultType, empty());
    const containsTools = !isEmpty(toolIds(stocktakingResults));
    const containsQuantityPositions = !isEmpty(toolWithQuantityIds(stocktakingResults)) ? true : !isEmpty(consumableIds(stocktakingResults));
    return createElement(Dialog, (Title = t("stocktaking.do_correction_booking"), {
        Body: singleton(createElement(DialogBody, {
            BookingText: state_1.BookingText,
            ComponentState: componentState,
            ContainsQuantityPositions: containsQuantityPositions,
            ContainsTools: containsTools,
            CountedBy: unwrap(state_1.CountedBy),
            CurrentUser: new StocktackingUser(props.UserName, "", props.UserId, undefined),
            Dispatch: dispatch,
            FormState: state_1.FormState,
            Stocktaking: props.Stocktaking,
            ToolAction: state_1.ToolAction,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-correction-booking-dialog",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(3, []));
            },
            TestId: "save-correction-booking-dialog",
            Variant: "blueButton",
        })]),
        IsOpen: props.StocktakingResultType != null,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

